<div class="content-notifications" (scroll)="onScroll($event)">
  <div *ngFor="let group of notificationGroups | keyvalue; index as groupIndex">
    <span class="time-notifications">{{group.value.title}}</span>
    <div class="wrapper-notification" *ngFor="let notification of group.value.notifications" (click)="notificationRedirect(notification)">
      <div class="wrapper-notification-left">
        <div class="wrapper-img" (click)="$event.stopPropagation()" [routerLink]="['/profile', notification.data.from.username]">
          <img *ngIf="!notification.data.from?.profile_photo_url" [src]="(notification.data.from?.subscriptions | checkActiveRole) === UserRoles.expert ? './assets/images/avatar-user-expert.png' : './assets/images/avatar-user.png'" alt="">
          <img *ngIf="notification.data.from?.profile_photo_url" [src]="notification.data.from?.profile_photo_url" alt="">
        </div>
        <div class="wrapper-info-notification">
          <span class="message-notification" [innerHTML]="notification.data.body"></span>
          <span class="time-notification">{{notification.created_at | timeAgo}}</span>
        </div>
      </div>
      <div class="wrapper-notification-right">
        <div *ngIf="notification | handleShowNotificationImg" class="wrapper-images">
          <div *ngIf="notification.type === NotificationTypesEnums.newComment" class="images-grid-notification" [ngClass]="{'image-2': (notification.data.comment.commentable.lyst?.lyst_image_url && notification.data.comment.commentable.lyst_item?.lyst_item_image_url)}">
            <div *ngIf="notification.data.comment.commentable.lyst?.lyst_image_url" class="image">
              <img [src]="notification.data.comment.commentable.lyst.lyst_image_url" alt="">
            </div>
            <div *ngIf="notification.data.comment.commentable.lyst_item?.lyst_item_image_url" class="image">
              <img [src]="notification.data.comment.commentable.lyst_item.lyst_item_image_url" alt="">
            </div>
          </div>
          <div *ngIf="notification.type === NotificationTypesEnums.newLike" class="images-grid-notification" [ngClass]="{'image-2': (notification.data.like.likeable.lyst?.lyst_image_url && notification.data.like.likeable.lyst_item?.lyst_item_image_url)}">
            <div *ngIf="notification.data.like.likeable.lyst?.lyst_image_url" class="image">
              <img [src]="notification.data.like.likeable.lyst.lyst_image_url" alt="">
            </div>
            <div *ngIf="notification.data.like.likeable.lyst_item?.lyst_item_image_url" class="image">
              <img [src]="notification.data.like.likeable.lyst_item.lyst_item_image_url" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="groupIndex !== notificationGroups.length - 1" class="line-gray"></div>
  </div>
</div>
